import { GlobalData } from "../../../Common/GlobalData";

export class MovingUpInRank {
    private readonly IND_RANK = '#indRank';
    private readonly PCT_INCREASE = '#pctIncrease';
    private readonly UPDATE_PARAMS = '#updateParams';
    private readonly GRID = '#grid';

    private static _instance: MovingUpInRank;

    private constructor() {
        this.init();
    }

    public static getInstance() {
        return this._instance || (this._instance = new this());
    }

    private init() {
        $(this.IND_RANK).kendoNumericTextBox({
            value: 20,
            format: '0',
            decimals: 0,
            min: 1
        });

        $(this.PCT_INCREASE).kendoNumericTextBox({
            value: 5,
            format: '0',
            decimals: 0,
            min: 0
        });

        $(this.UPDATE_PARAMS).on('click', () => {
            const grid = $(this.GRID).data('kendoGrid')!;
            const options: kendo.data.DataSourceOptions = {
                transport: {
                    read: GlobalData.URL_BASE +
                        GlobalData.URL_SUFFIX_IBD_MARKET_SMITH_INDUSTRY_GROUPS_MOVING_UP_IN_RANK +
                        '?rank=' + $(this.IND_RANK).val() + '&increase=' + $(this.PCT_INCREASE).val()
                },
                serverSorting: false
            };
            grid.setDataSource(new kendo.data.DataSource(options));
        });

        $(this.GRID).kendoGrid({
            dataSource: {
                transport: {
                    read: GlobalData.URL_BASE +
                        GlobalData.URL_SUFFIX_IBD_MARKET_SMITH_INDUSTRY_GROUPS_MOVING_UP_IN_RANK
                },
                serverSorting: false
            },
            height: 915,
            sortable: true,
            groupable: false,
            pageable: false,
            detailInit: this.openDetail,
            columns: [{
                field: 'sector',
                title: 'Sector',
                width: '10%',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
            }, {
                field: 'industryName',
                title: 'IndustryName',
                width: '20%',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
            }, {
                field: 'numStocks',
                title: 'NumStocks',
                width: '10%',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
            }, {
                field: 'rank',
                title: 'Rank',
                width: '10%',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
            }, {
                field: 'rankLastWeek',
                title: 'Rank1Wk',
                width: '10%',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
            }, {
                field: 'rank3MonthsAgo',
                title: 'Rank3Mo',
                width: '10%',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
            //}, {
            //    field: 'rank6MonthsAgo',
            //    title: 'Rank6Mo',
            //    width: '10%',
            //    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
            //    attributes: { 'class': 'table-cell grid-cell-center' },
            }, {
                field: 'pctHistory',
                title: 'MaxPctHistory',
                width: '10%',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                format: "{0:p0}",
            }, {
                field: 'indRS',
                title: 'IndRS',
                width: '10%',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
            }, {
                field: 'industrySymbol',
                title: 'IndSymbol',
                width: '10%',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
            }]
        });
    }

    private openDetail(e: any) {
        $("<div/>").appendTo(e.detailCell).kendoGrid({
            dataSource: {
                transport: {
                    read: GlobalData.URL_BASE +
                        GlobalData.URL_SUFFIX_IBD_MARKET_SMITH_INDUSTRY_GROUPS_MOVING_UP_IN_RANK +
                        '/Detail?industrySymbol=' + e.data.industrySymbol
                },
                serverPaging: false,
                serverSorting: false,
                serverFiltering: false,
            },
            scrollable: false,
            columns: [
                {
                    field: 'symbol',
                    title: 'Symbol',
                    width: '50px',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { 'class': 'table-cell grid-cell-center' },
                },
                {
                    field: 'companyName',
                    title: 'CompanyName',
                    width: '100px',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { 'class': 'table-cell grid-cell-center' },
                },
                {
                    field: 'currentPrice',
                    title: 'CurrentPrice',
                    width: '50px',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { 'class': 'table-cell grid-cell-center' },
                    format: '{0:c2}',
                },
                {
                    field: 'compRating',
                    title: 'CompRating',
                    width: '50px',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { 'class': 'table-cell grid-cell-center' },
                },
                {
                    field: 'relativeStrengthRating',
                    title: 'RSRating',
                    width: '50px',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { 'class': 'table-cell grid-cell-center' },
                },
                {
                    field: 'newHigh',
                    title: 'NewHigh',
                    width: '50px',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { 'class': 'table-cell grid-cell-center' },
                },
                {
                    field: 'earningsStability',
                    title: 'Stability',
                    width: '50px',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { 'class': 'table-cell grid-cell-center' },
                },
                {
                    field: 'priceVsFiftyDay',
                    title: 'PriceVsFiftyDay',
                    width: '50px',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { 'class': 'table-cell grid-cell-center' },
                },
                {
                    field: 'earningsPerSharePctChg',
                    title: 'EPSPctChg',
                    width: '50px',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { 'class': 'table-cell grid-cell-center' },
                },
                {
                    field: 'salesPctChg',
                    title: 'SalesPctChg',
                    width: '50px',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { 'class': 'table-cell grid-cell-center' },
                },
            ]
        });
    }
}
